import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'


export const requestCreateAPIKey = packet => {
  return {
    type: 'REQUEST_CREATE_API_KEY',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateAPIKeySuccess = data => ({
  type: 'RECEIVE_CREATE_API_KEY_SUCCESS',
  data
})

export const receiveCreateAPIKeyFail = data => ({
  type: 'RECEIVE_CREATE_API_KEY_FAIL',
  data
})

export const tryToCreateAPIKey = packet => (dispatch, getState) => {

  dispatch(requestCreateAPIKey(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/api-key/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveCreateAPIKeySuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveCreateAPIKeyFail({errors:e, lastSubmit: packet}));
    })
}
